import { Routes } from '@angular/router';
import { authGuard } from '../app/guards/auth-guard';
import { redirectGuard } from './guards/redirect.guard';

export const routes: Routes = [

  {
    path: '',
    loadComponent: () =>
      import('./pages/home/home.page').then(m => m.HomePage),
    canActivate: [redirectGuard]
  },

  {
    path: 'contact',
    loadComponent: () =>
      import('./pages/contact/contact.page').then(m => m.ContactPage),
    canActivate: [redirectGuard]
  },

  {
    path: 'login',
    loadComponent: () =>
      import('./pages/login/login.page').then(m => m.LoginPage),
    canActivate: [redirectGuard]   // 🔥 ADD THIS
  },

  {
    path: 'forgot-password',
    loadComponent: () => import('./pages/forgot-password/forgot-password.page').then( m => m.ForgotPasswordPage)
  },

  {
    path: 'register',
    loadComponent: () =>
      import('./pages/register/register.page').then(m => m.RegisterPage),
    canActivate: [redirectGuard]   // 🔥 ADD THIS
  },

  {
    path: 'dashboard',
    loadComponent: () =>
      import('./pages/dashboard/dashboard.page').then(m => m.DashboardPage),
    canActivate: [authGuard]
  },

  {
    path: 'admin',
    loadComponent: () =>
      import('./pages/admin/admin.page').then(m => m.AdminPage),
    canActivate: [authGuard]   // 🔥 ALSO PROTECT THIS
  },

  {
    path: '**',
    redirectTo: ''
  }
];